import React from 'react';
import '../styles/Organigrama.css';
import pdfUrl from '../documentos/ORGANIGRAMA_2024.pdf';


function Organigrama(){
    
    return (
        <div className="pdf-container">
            <h2>Organigrama | Municipalidad Provincial de Chumbivilcas 2024</h2>

            {/* Vista previa en iframe */}
            <iframe
                src={pdfUrl}
                title="Vista previa PDF"
                className="pdf-iframe"
            ></iframe>

            {/* Botón para abrir en nueva pestaña */}
            <a
                href={pdfUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="pdf-boton"
            >
                Ver documento completo
            </a>
        </div>
    );
};

export default Organigrama;